import React from "react"
import { Layer, Source } from "react-mapbox-gl"
import { connect } from "react-redux"
import { layersSelectors } from "../../../../../../state/layers"
import { MapStyleProperties } from "../../../../../../utils/mapbox/mapStyleProperties"
import mapboxPresentationProperties from "../../../../../utils/mapboxPresentationProperties"

const mapStateToProps = (state) => ({
  retailFeatures: layersSelectors.selectRetailYearlyRentFeatures(state),
})

type StateProps = ReturnType<typeof mapStateToProps>;
type Props = StateProps;

const RETAIL_RATE_SOURCE_ID = "retail-rate-source"

const LAYER_FILL_PAINT = {
  "fill-opacity": 0.5,
  "fill-color": [
    "interpolate",
    ["linear"],
    [
      "get",
      MapStyleProperties.RentFeatureFieldId.Value
    ],
    10,
    "#fd0d0d",
    20,
    "#fff305",
    30,
    "#0fe600",
    40,
    "#16e7fe",
    50,
    "#024be8",
  ]
}

class RetailRateFeatureLayer extends React.PureComponent<Props, {}> {
  render() {
    return (
      <>
        <Source
          id={RETAIL_RATE_SOURCE_ID}
          geoJsonSource={{
            type: "geojson",
            data: {
              type: "FeatureCollection",
              features: this.props.retailFeatures
            }
          }}
        />
        <Layer
          id={MapStyleProperties.LayerId.RetailRateFill}
          type={MapStyleProperties.LayerType.Fill}
          sourceId={RETAIL_RATE_SOURCE_ID}
          paint={LAYER_FILL_PAINT}
          before={MapStyleProperties.LayerId.UsaBuildings}
        />
        <Layer
          id={MapStyleProperties.LayerId.RetailRateBorder}
          type={MapStyleProperties.LayerType.Line}
          sourceId={RETAIL_RATE_SOURCE_ID}
          paint={mapboxPresentationProperties.rentLayersLinePaint}
          before={MapStyleProperties.LayerId.UsaBuildings}
        />
        <Layer
          id={MapStyleProperties.LayerId.RetailRateSymbol}
          type={MapStyleProperties.LayerType.Symbol}
          sourceId={RETAIL_RATE_SOURCE_ID}
          layout={mapboxPresentationProperties.rentLabelsSymbolLayout(MapStyleProperties.RentFeatureFieldId.Value, { prefix: "$" })}
          paint={mapboxPresentationProperties.rentLayersSymbolPaint}
          minZoom={13}
          before={MapStyleProperties.LayerId.UsaBuildings}
        />
      </>
    )
  }
}

export default connect(
  mapStateToProps
)(RetailRateFeatureLayer);
